import type { AssignmentStatus } from "./types";

/**
 * API returns PascalCase enum strings (JsonStringEnumConverter default);
 * UI and i18n use camelCase keys.
 */
export function normalizeAssignmentStatus(
    value: AssignmentStatus | string | undefined | null
): AssignmentStatus {
    if (value == null || value === "") {
        return "planned";
    }
    switch (value) {
        case "Planned":
        case "planned":
            return "planned";
        case "InProgress":
        case "inProgress":
            return "inProgress";
        case "Completed":
        case "completed":
            return "completed";
        default:
            return "planned";
    }
}
